<template>
	<section v-if="snapwidgetId" class="social-section">
		<div class="row">
			<div class="columns column12 align-center">
				<picture>
					<source :srcset="imageWebp" type="image/webp" />
					<source :srcset="image" />
					<img :src="image" :alt="imageAlt" class="icon-image fade-animate fade-up" loading="lazy" />
				</picture>
				<h2>{{ header }}</h2>
				<a :href="url" target="blank">{{ handle }}</a>
			</div>
			<div class="columns column12 snap-section">
				<ClientOnly>
					<component :is="'script'" src="https://snapwidget.com/js/snapwidget.js" async />

					<iframe
						:src="`https://snapwidget.com/embed/${snapwidgetId}`"
						class="snapwidget-widget"
						allowtransparency="true"
						frameborder="0"
						scrolling="no"
						style="border: none; overflow: hidden; width: 100%"
					/>
				</ClientOnly>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	url: { type: String, default: '' },
	handle: { type: String, default: '' },
	snapwidgetId: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.snap-section {
	margin: 50px auto 0;
}

.social-section {
	margin: 0 auto;
	padding: 50px 0;

	.row {
		max-width: 1200px;
	}

	h2 {
		max-width: 270px;
		margin: 0 auto 20px;
		color: var(--header-color-senary);
	}

	img {
		margin: 0 auto 20px;
	}

	a {
		color: var(--body-color);
		text-decoration: none;
		text-transform: uppercase;
	}
}
</style>
